import { render, staticRenderFns } from "./AddTopicLabel.vue?vue&type=template&id=166958e9&scoped=true&"
import script from "./AddTopicLabel.vue?vue&type=script&lang=js&"
export * from "./AddTopicLabel.vue?vue&type=script&lang=js&"
import style0 from "./AddTopicLabel.vue?vue&type=style&index=0&id=166958e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166958e9",
  null
  
)

export default component.exports